
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Dialog',
  emits: ['close'],
});
